var map = {
	"./bmath": 18,
	"./bmath.js": 18,
	"./exporter": 19,
	"./exporter.js": 19,
	"./file": 20,
	"./file.js": 20,
	"./index": 38,
	"./index.js": 38,
	"./loader": 21,
	"./loader.js": 21,
	"./proxy": 22,
	"./proxy.js": 22,
	"./recognize": 39,
	"./recognize.js": 39,
	"./seqgen": 40,
	"./seqgen.js": 40,
	"./svg": 14,
	"./svg.js": 14,
	"./tree": 41,
	"./tree.js": 41
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 147;



/*****************
 ** WEBPACK FOOTER
 ** ./src/utils ^\.\/.*$
 ** module id = 147
 ** module chunks = 0
 **/